import { ResponseGetMerchantSettings } from "@CommonApi/merchant-settings";
import { ReportSettings } from "./types";

export const REPORT_SETTING_KEYS = [
  "basePogReportId",
  "storePogReportId",
  "singleStorePogReportId",
  "categoryRangeReviewReportId",
] as const;

export type ReportSettingKey = (typeof REPORT_SETTING_KEYS)[number];

export const mapMerchantSettingsToReportSettings = (
  settings: ResponseGetMerchantSettings | null,
): ReportSettings | null => {
  if (!settings) {
    return null;
  }

  return {
    base_pog_report_id: settings.basePogReportId,
    store_pog_report_id: settings.storePogReportId,
    single_store_pog_report_id: settings.singleStorePogReportId,
    category_range_review_report_id: settings.categoryRangeReviewReportId,
  };
};
